var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJourneyBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.001,
    height: 20,
    viewBox: "0 0 26.001 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "journey--blue",
    transform: "translate(0 -52.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(0 52.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M90.149,52.552q.033.83.067,1.659H89.139q.033-.83.067-1.659h-2.62l-5.266,20H88.4l.067-1.659h2.417q.034.83.067,1.659h7.083l-5.266-20ZM89.039,56.7h1.276q.093,2.3.185,4.61H88.854Q88.947,59,89.039,56.7Zm-.47,11.712q.093-2.307.185-4.614H90.6q.093,2.307.185,4.614Z",
    transform: "translate(-76.677 -52.552)",
    fill: "#004a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M297.2,52.552h-.892l6.673,20h2.411Z",
    transform: "translate(-279.391 -52.552)",
    fill: "#004a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M8.192,52.552,0,72.552H2.411l6.673-20Z",
    transform: "translate(0 -52.552)",
    fill: "#004a93"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJourneyBlue);
export default __webpack_public_path__ + "static/media/journey--blue.93ec4a1655aafe599ece2c6c065b68a7.svg";
export { ForwardRef as ReactComponent };